import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Raza/generarExcel`, method: 'POST', body: list, token: token})
}
